export const APP_VERSION = '44e9afb';
